import { render, staticRenderFns } from "./LinkText.vue?vue&type=template&id=a349c6d4&"
import script from "./LinkText.vue?vue&type=script&lang=ts&"
export * from "./LinkText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports